export default {
   partnerCompanies: {
      allPartnerCompaniesBenefitsRelation: [],
      loading: false,
      data: [],
      pagination: {
         tokenPages: [],
         totalPages: 0,
         currentPage: 1,
      }
   }
}
